export const EMAIL = 'email';
export const GUEST = 'guest';
export const INVITEE = 'invitee';
export const FACEBOOK = 'facebook';



// WEBPACK FOOTER //
// ./src/lib/account-types.js